import { Helmet } from "react-helmet";
import HeroSection from "@/components/hero-section";
import FeaturesSection from "@/components/features-section";
import AboutSection from "@/components/about-section";
import ProcessSection from "@/components/process-section";
import ProductsSection from "@/components/products-section";
import ServicesSection from "@/components/services-section";
import TestimonialSection from "@/components/testimonial-section";
import CTASection from "@/components/cta-section";
import ContactSection from "@/components/contact-section";
import MapSection from "@/components/map-section";
import { products, testimonials } from "@/lib/data";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Varsha Seeds - Premier Agricultural Seed Manufacturer</title>
        <meta name="description" content="Varsha Seeds provides high-quality agricultural seeds and processing services for farmers. Discover our premium seed varieties for optimal yields and sustainable farming." />
        <meta name="keywords" content="agricultural seeds, seed manufacturing, farm seeds, crop seeds, wheat seeds, rice seeds, agricultural supplies" />
      </Helmet>
      
      <HeroSection />
      <FeaturesSection />
      <AboutSection />
      <ProcessSection />
      <ProductsSection products={products} />
      <ServicesSection />
      <TestimonialSection testimonials={testimonials} />
      <CTASection />
      <ContactSection />
      <MapSection />
    </>
  );
};

export default Home;
